<template>
  <v-dialog
    fullscreen
    content-class="select-service-provider-popup"
    :value="visiblePopup"
    @keydown.esc="onEscapeClicked"
    @click:outside="onEscapeClicked"
  >
    <div class="add-worker">
      <div class="select-service-provider-header">
        <div class="popup-title">{{ $t('project.select.service.provider') }}</div>
        <new-project-control-buttons
          :showCreateButton="true"
          :actionTitle="$t('project.save.changes')"
          :actionDisabled="saveButtonDisabled"
          @onEscapeClicked="onEscapeClicked"
          @onActionClicked="onSaveClicked"
        />
      </div>
      <div v-if="workers.length" class="select-workers-container">
        <new-project-provider :newProject="newProject" />
      </div>
      <div v-else class="central-content primary-background loading-container">
        <v-progress-circular :size="70" :width="7" color="#4D9FEB" indeterminate />
      </div>
      <yes-no-popup
        :visible-popup="showCloseConfigrmationPopup"
        title="project.close.changes.title"
        message="project.close.changes.message"
        yesCaption="confirm.ok"
        noCaption="confirm.cancel"
        @clicked="onClickYesNoButton"
      />
    </div>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { emptyProject } from '@/constants/projects';

import YesNoPopup from '@/components/popup/YesNoPopup.vue';
import NewProjectProvider from '@/components/newProject/NewProjectProvider.vue';
import NewProjectControlButtons from '@/components/newProject/NewProjectControlButtons.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectServiceProviderPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: { YesNoPopup, NewProjectControlButtons, NewProjectProvider },
  props: {
    visiblePopup: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    newProject: cloneDeep(emptyProject),
    showCloseConfigrmationPopup: false,
  }),
  computed: {
    ...mapGetters(['workers']),
    saveButtonDisabled() {
      const {
        serviceProviderId, startDate, endDate, projectTotalPrice,
      } = this.newProject.projectProviderData;

      return !(
        serviceProviderId &&
        startDate &&
        endDate &&
        projectTotalPrice !== null &&
        projectTotalPrice !== undefined
      );
    },
  },
  mounted() {
    this.initProject();
  },
  methods: {
    initProject() {
      if (moment(this.project.startDate).isAfter(moment())) {
        this.newProject.projectProviderData.startDate = this.project.startDate;
        this.newProject.projectProviderData.endDate = this.project.endDate;
      }

      this.newProject.projectProviderData.projectDurationHours = this.project.estimation;
    },
    onClickYesNoButton(result) {
      this.showCloseConfigrmationPopup = false;
      if (result) {
        this.newProject = cloneDeep(emptyProject);
        this.$emit('onEscapeClicked');
      }
    },
    onEscapeClicked() {
      this.showCloseConfigrmationPopup = true;
    },
    onSaveClicked() {
      this.$emit('onSaveClicked', this.newProject.projectProviderData);
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.select-service-provider-popup {
  display: flex;
  justify-content: space-around;
  background-color: var(--bg-secondary);
  height: 100vh;
  padding: rem(40) rem(192);
}

.add-worker {
  display: flex;
  flex-direction: column;
  max-width: rem(917);

  .select-workers-container {
    .workers {
      background-color: var(--bg-primary);
      border-radius: $radius-md;
      box-shadow: 0 0 4px 0 rgba(14, 31, 51, 0.13);
      padding: rem(24);
    }

    .project-provider-header {
      .start-date {
        padding-left: 0px;

        label.v-label.v-label--active.theme--light {
          color: var(--text-tertiary);
          font-size: rem(10);
          letter-spacing: rem(0.8);
          line-height: rem(10);
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.loading-container {
  padding: rem(40);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.select-service-provider-header {
  display: flex;
  justify-content: space-between;
}

.popup-title {
  color: var(--text-tertiary);
  font-size: rem(20);
  font-weight: 900;
  letter-spacing: 0;
  line-height: rem(24);
}
</style>
